module.exports = __webpack_public_path__ + "media/images/curriculum_3-53ccd50f8ea282f52a0402cc263ac1ca.png";